export const mutations = {
  STORE_DEAD_STOCKS(state, deadstocks) {
    state.deadstocks = deadstocks;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/deadstocks/mutations.js